module.exports = __webpack_public_path__ + "img/yazam-logo.291b287a.png";